import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";
// const BASE_URL = "http://localhost:5500";
// const BASE_URL = "http://52.87.3.228:5500";

function HomeBanner() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [banner, setBanner] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});

  const [combineData, setCombineData] = useState([]);
  const [selectedChildCategories, setSelectedChildCategories] = useState([]);
  const [selectedParentCategory, setSelectedParentCategory] = useState();
  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [ServiceTypeOptions, setServiceTypeOptions] = useState([]);
  const [Packageoption, setPackageOption] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [SelectedChildCategory, setSelectedChildCategory] = useState("");
  const [editorData, setEditorData] = useState("");
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [shortcutHeadings, setShortcutHeadings] = useState([]);
  const [selectedHeading, setSelectedHeading] = useState("");

  const getShortcutHeadings = async () => {
    try {
      const response = await privateRequest.get(
        `ServiceShortcutHeading/GetShortcuteByStatus`
      );
      // setCombineData(response?.data?.data);
      setShortcutHeadings(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get("Service/CombineApis");
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getBanner = async () => {
    try {
      const response = await privateRequest.get(
        "/HomeBottomBanners/AllHomeBanner"
      );
      setBanner(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteBanner = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `HomeBottomBanners/DeleteHomeBanner/${_id}`
        );
        getBanner();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire(
        "Error!",
        "Failed to delete item.",
        error.response.data.message
      );
    }
  };

  const AddHomeBanner = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("bannerImg", selectedFile);
      formData.append("Status", selectedStatus);
      if (selectedParentCategory) {
        formData.append("PCatId", selectedParentCategory.value);
      }
      if (selectedChildCategories?.value) {
        formData.append("CCatId", selectedChildCategories?.value || "");
      }
      if (ServiceTypeOptions?.value) {
        formData.append("serviceID", ServiceTypeOptions?.value || "");
      }
      formData.append("SectionId", selectedHeading?.value || "");

      let response;
      if (selectedItem._id) {
        response = await privateRequest.put(
          `HomeBottomBanners/UpdateHomeBanner/${selectedItem._id}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Banner  updated successfully!",
        });
      } else {
        response = await privateRequest.post(
          "/HomeBottomBanners/AddHomeBanner",
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Banner added successfully!",
        });
      }

      console.log("POST Response:", response);
      getBanner();
      setShowModal(false);
      // Reset form fields after successful submission
      setSelectedFile(null);
      setSelectedStatus("");
      setSelectedItem({});
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
    setSelectedChildCategory("");
  };

  const handleChildCategoryChange = (selectedOption) => {
    setSelectedChildCategories({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
  };
  const handleChangeServices = (selectedOption) => {
    setServiceTypeOptions({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
  };

  const handleHeadingChange = (selectedOption) => {
    const selectedGroupId = selectedOption.value;
    const selectedGroupLabel = selectedOption.label;

    setSelectedHeading({
      label: selectedGroupLabel,
      value: selectedGroupId,
    });
  };

  useEffect(() => {
    getAllDocumentData();
    getBanner();
    getShortcutHeadings();
  }, []);

  useEffect(() => {
    const childCategorySelectOptions = combineData?.childCategories
      ?.filter(
        (category) => category.PCName[0] === selectedParentCategory?.value
      )
      ?.map((category) => ({
        value: category._id,
        label: category.CCName,
      }));
    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.childCategories]);

  useEffect(() => {
    const serviceGroupSelectOptions = combineData?.serviceGroups
      ?.filter((group) => group.PCName[0] === selectedParentCategory?.value)
      ?.map((group) => ({
        value: group._id,
        label: group.GroupName,
      }));
    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  useEffect(() => {
    if (combineData?.newServiceId && combineData?.Package) {
      const selectedServices = combineData.newServiceId
        .filter(
          (service) =>
            service?.ChildCatIDs._id === selectedChildCategories?.value
        )
        .flatMap((service) =>
          service.ServiceVarients.map((varient) => ({
            value: varient?._id,
            label: `${service.ServiceName} (${varient?.ServiceType?.Name !== "NA"
              ? varient?.ServiceType?.Name
              : service?.ChildCatIDs?.CCName
              })`,
            type: "Service",
          }))
        );

      const selectedPackages = combineData.Package.filter((packag) =>
        packag.ChildId.includes(selectedChildCategories?.value)
      ).map((packag) => ({ value: packag._id, label: packag.packageTitle }));

      setServiceOptions([...selectedServices, ...selectedPackages]);
    } else {
      setServiceOptions([]);
    }
  }, [selectedChildCategories, combineData]);

  useEffect(() => {
    if (
      selectedItem &&
      selectedChildCategories.value &&
      serviceOptions.length > 0
    ) {
      const id = serviceOptions?.filter(
        (serviceItem) => serviceItem.value === selectedItem?.serviceID
      );

      if (id && id.length > 0) {
        const values = {
          value: selectedItem?.serviceID,
          label: id[0]?.ServiceName || "",
          type: "Service",
        };

        console.log("values", values);
        console.log("id", id);
        setServiceTypeOptions(id[0]);
        // setServiceValues(values); // Set the service values state
      }
    }
  }, [selectedChildCategories, selectedItem, serviceOptions]);

  const handleEditButtonClick = (event, item) => {
    setSelectedItem(item);

    setSelectedChildCategories({
      label: item?.CCatId?.CCName,
      value: item?.CCatId?._id,
    });

    setSelectedFile(item.OffersImage);
    setSelectedFile(null);
    setSelectedStatus(item.Status == true ? 1 : 0);
    setImagePreview(Image_URL + item.bannerImg);
    setSelectedFile(item.bannerImg);
    setSelectedHeading({
      label: item?.SectionId?.Heading,
      value: item?.SectionId?._id,
    });

    setShowModal(true);
  };

  useEffect(() => {
    if (combineData?.parentCategories && selectedItem) {
      setSelectedParentCategory({
        value:
          combineData?.parentCategories?.find(
            (category) => category._id === selectedItem?.PCatId?._id
          )?._id || "",
        label:
          combineData?.parentCategories?.find(
            (category) => category._id === selectedItem?.PCatId?._id
          )?.PCName || "",
      });
    }
  }, [combineData, selectedItem]);

  console.log("selectedItem", selectedParentCategory);
  console.log("combinedata", combineData);
  return (
    <>
      {banner.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Home Banner</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);
                        setSelectedChildCategories([]);
                        setSelectedHeading(null);
                        setSelectedParentCategory(null);
                        setServiceTypeOptions(null);
                        setImagePreview(null);
                        setSelectedStatus("");
                        setSelectedItem("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm no-footer text-center"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">ParentId</th>
                            <th scope="col">ChildId</th>
                            <th scope="col">Home Banner</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {banner?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.PCatId?.PCName}
                              </td>
                              <td className="align-center">
                                {item?.CCatId?.CCName}
                              </td>

                              <td className="align-center">
                                {item?.bannerImg && (
                                  <img
                                    className="object-fit-contain"
                                    src={`${Image_URL}${item?.bannerImg}`}
                                    alt=""
                                    height="100"
                                    width="100%"
                                  />
                                )}
                              </td>

                              <td>
                                <span
                                  className={`badge ${item?.Status.toString() === "true"
                                    ? "badge-primary"
                                    : "badge-danger"
                                    }`}
                                >
                                  {item?.Status.toString() === "true"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={(event) => {
                                      handleEditButtonClick(event, item);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteBanner(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Home Banner
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddHomeBanner}>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Parent Category</label>
                      <Select
                        isClearable
                        label={selectedParentCategory}
                        value={selectedParentCategory}
                        onChange={handleParentCategoryChange}
                        options={
                          combineData?.parentCategories?.map((category) => ({
                            value: category._id,
                            label: category.PCName,
                          })) || []
                        }
                      />
                    </div>
                  </div>
                  <div className="form-group col-lg-6">
                    <label>Heading</label>
                    <Select
                      options={shortcutHeadings?.map((group) => ({
                        value: group._id,
                        label: group.Heading,
                      }))}
                      onChange={handleHeadingChange}
                      value={selectedHeading}
                      isMulti={false}
                      isClearable
                    />
                  </div>
                  <div className="col-lg-4">
                    <button
                      type="button"
                      title="Remove Service"
                      onClick={() => {
                        setSelectedChildCategories([]);
                      }}
                    />
                    <div className="form-group">
                      <label>Child Category</label>
                      <Select
                        isClearable
                        value={selectedChildCategories}
                        label={selectedChildCategories}
                        onChange={handleChildCategoryChange}
                        options={childCategoryOptions}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <button
                      type="button"
                      title="Remove Service"
                      onClick={() => {
                        setServiceTypeOptions(null);
                      }}
                    />
                    <div className="form-group">
                      <label>ItemId</label>
                      <Select
                        isClearable
                        value={ServiceTypeOptions}
                        label={ServiceTypeOptions}
                        options={serviceOptions}
                        onChange={(selectedOptions) =>
                          handleChangeServices(selectedOptions)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="form-group">
                      <label className="mb-0">Image</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  {imagePreview && (
                    <div className="col-lg-12">
                      <img
                        width="80"
                        height="50"
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  )}
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItem._id ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default HomeBanner;
